import { useAtomValue } from 'jotai';

import {
  selectedVersionControlIdAtomFamily,
  templateCreationRecordIdAtom,
} from '../template-builder/atoms';
import { structureGenerationStreamStateAtomFamily } from './atoms';
import { StreamStatus } from './types';

export const useStructureStreamState = () => {
  const templateCreationRecordId = useAtomValue(templateCreationRecordIdAtom) ?? '';
  const selectedVersionControlId = useAtomValue(
    selectedVersionControlIdAtomFamily(templateCreationRecordId)
  );
  const streamState = useAtomValue(
    structureGenerationStreamStateAtomFamily({
      templateCreationRecordId,
      versionControlId: selectedVersionControlId ?? '',
    })
  );

  return {
    isStreaming: streamState.status === StreamStatus.STREAMING,
    isWaitingStart: streamState.status === StreamStatus.WAITING_START,
    animationType: streamState.animationType,
    isIdle: streamState.status === StreamStatus.IDLE,
    isError: streamState.status === StreamStatus.ERROR,
  };
};
